import React from 'react';
import CreditCardsContainer from './CreditCardsContainer';
import AppBodyWithSidebar from 'app/components/layout/AppBodyWithSidebar';
import TemplateShell2 from 'app/components/layout/TemplateShell2';

const CreditCardsPage = () => {
  return (
    <AppBodyWithSidebar>
      <TemplateShell2 header="Manage Credit Cards" showBackArrow={false}>
        <CreditCardsContainer />
      </TemplateShell2>
    </AppBodyWithSidebar>
  );
};

export default CreditCardsPage;
